/*
---
covers:
  - frontend/src/components/entrevista-riesgos-step.tsx
  - frontend/src/components/entrevista-completion-summary.tsx
  - frontend/src/pages/empresa/mi_espacio/mi-acciones.tsx
  - frontend/src/pages/empresa/mi_espacio/mi-cumplimiento.tsx
  - frontend/src/pages/empresa/mi_espacio/mi-soportes.tsx
  - frontend/src/pages/empresa/mi_espacio/mi-soportes-solicitudes.tsx
  - frontend/src/pages/sgsst/evidencias/mi-solicitudes.tsx
  - frontend/src/hooks/sgsst/riesgos/use-entrevista.ts
revisado: 2026-09-11
---
*/
import type {ManualSeccion} from '../types'

export const seccion: ManualSeccion = {
  id: 'tu-entrevista-y-tus-tareas',
  titulo: 'Tu entrevista y tus tareas',
  resumen: 'Tu entrevista de identificación de peligros y el seguimiento de las acciones que tienes pendientes.',
  enCorto: [
    'Su entrevista de peligros y sus pendientes',
    'Conteste, suba fotos y cierre acciones',
    'Sus datos personales viven en Mi información',
  ],
  replayId: 'tu-entrevista-y-tus-tareas',
  operaciones: [
    {
      id: 'responder-entrevista',
      titulo: 'Responder tu entrevista de identificación de peligros',
      como: 'Dentro de «Mi información» → «Ficha», el botón «Ver mis riesgos» abre la entrevista: una pregunta a la vez con opciones para escoger («Sí»/«No» u otras según el tema), una barra de progreso arriba y un botón para «Deshacer» tu última respuesta si te equivocaste.',
      porQueImporta:
        'Esta entrevista es donde identificas los peligros reales de tu puesto de trabajo — alturas, químicos, ruido, condiciones psicosociales — y alimenta directamente la matriz de riesgos que tu empresa debe mantener bajo la Resolución 0312/2019.',
    },
    {
      id: 'subir-foto-de-hallazgo',
      titulo: 'Subir una foto cuando reportas un hallazgo',
      como: 'Si una de tus respuestas señala un peligro, Kairos te interpone una pantalla pidiendo una foto de evidencia antes de seguir con la siguiente pregunta; el botón para saltarla te deja continuar sin foto si no la tienes a mano en ese momento.',
      porQueImporta:
        'Una foto del hallazgo real (no solo tu palabra) es lo que tu empresa y su ARL necesitan para intervenir el riesgo con evidencia — puedes completarla después desde tu página de inicio si la saltaste.',
    },
    {
      id: 'ver-lo-que-me-piden',
      titulo: 'Ver lo que te piden y aportar lo que te falta',
      como: '«Lo que me piden», en Mi espacio, lista lo que tu cargo te exige con una frase corta por renglón («Está al día», «Te lo están pidiendo», «Se te vence pronto») y el porqué escrito debajo. El botón «Aportar el documento» abre tus archivos —hoy no la cámara: si necesitas una foto, tómala con tu teléfono y súbela desde ahí—, y lo que envías queda «enviado, esperando revisión» hasta que el responsable lo confirme. Mientras nadie lo haya mirado puedes retirarlo.',
      porQueImporta:
        'Es el mismo veredicto que verá quien decida si entras a la obra, con las mismas palabras: si dice que hoy no estás habilitado, ahí está exactamente qué falta. Y tú nunca confirmas tu propio soporte — eso lo hace el responsable del SG-SST, que es lo que le da valor ante un inspector.',
    },
    {
      id: 'trabajar-tus-acciones',
      titulo: 'Trabajar las acciones del plan que tienes asignadas',
      como: 'En «Mis tareas del plan» ves cada acción con su estado («Pendiente» → «En curso» → «Cumplida», solo puedes avanzar, nunca retroceder) y espacio para notas y evidencia; también aparecen ahí las actividades del plan de trabajo anual donde te toca marcar «Ejecutado» mes a mes.',
      porQueImporta:
        'Estas son las acciones correctivas o de mejora donde tu empresa te puso como responsable — moverlas de estado es lo que deja el rastro de que el plan de mejoramiento sí se está ejecutando, no solo escribiendo.',
    },
    {
      id: 'responder-solicitudes-de-soporte',
      titulo: 'Responder cuando tu empresa te solicita un soporte',
      como: 'En «Mis soportes y solicitudes», la pestaña «Solicitudes» lista lo que tu empresa te ha pedido subir (con su fecha límite); el botón junto a cada una abre el selector de archivo para adjuntarlo directamente.',
      porQueImporta:
        'Muchos soportes del SG-SST (certificados médicos, cursos, designaciones) solo los tienes tú — esta es la vía directa para entregárselos a tu empresa sin pasar por correo ni papel.',
    },
  ],
}
